import base from '@/http/url_base';

export default {
  TIERS: base.API + '/tiers',
  GET_REQUIREMENTS: base.API + '/tiers/requirements',
  //SEARCH_TIERS: base.API + '/tiers/search',
  NOTE: base.API + '/tiers-notes',
  ECHANGE: base.API + '/tiers/echanges',
  GET_ECHANGE_REQUIREMENTS: base.API + '/tiers/echanges/requirements',
  GET_ECHANGE: '/echanges',
  // TIERS_PARAM: base.API + '/tiers-params',
};
